import React, {Component} from 'react';
import ElementProps from '../ElempentProps';
import objeler from '../objeler';
import ModalBase from '../../components/ModalDialog/ModaBase'
import Connect from './Connect';

class ModalDialogConnect extends Component<props> {
    static defaultProps = {
        objects: {}
    };
    customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '800px',
            height: '550px',
            transform: 'translate(-50%, -50%)'
        }
    };

    constructor(props) {
        super(props);
        this.state = {modalDocIsOpen: false, setDocIsOpen: false, ElementProps};
        this.FilePropRef = React.createRef();
    }

    afterOpenModal = () => {
    }
    closeModal = (b) => {
        if (b !== "Cancel") {
            objeler.buildOracle = {...objeler.buildOracleValues};
            objeler.buildOracleValues = {};
            this.props.closeModal("dosya ismi");
        } else {
            objeler.buildOracleValues = {};
            this.props.closeModal("Cancel");
        }
        return;
        objeler.closeModalFile(e);
        if (b === "OK")
            this.props.closeModalFile(objeler.tarik);
        else
            this.props.closeModalFile("Cancel");
    }

    render() {
        console.log('objeler.buildOracle.dbtype', objeler)
        const {objects, DocProps, isOpen} = this.props;
        const {classes} = this.props;
        return (
            <div>
                <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.closeModal}
                    title={objeler.buildOracle.dbtype == 'Oracle' ? 'Oracle Connection' : 'PostgreSQL Connection'}
                    dialogId='oracleconnection'
                >
                    <table className="ta ble" height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                <Connect
                                    onDocChange={this.onDocChange} FileName={objeler.ModalDocParameters.FileName}
                                    DocProps={objeler.ModalDocParameters}
                                    checkdbOracle={this.props.checkdbOracle} DbType={objeler.buildOracle.dbtype}
                                ></Connect>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>
            </div>
        );
    }
}

export default ModalDialogConnect;